module.exports = __webpack_public_path__ + "img/floor_f3_02.2cc5e959.png";